import http from './http';

// 短线配置日志分页
export const getSmsConfigLogPage = (data) => {
  return http({
    method: 'POST',
    url: '/member-coupon-sms-config/log/page',
    data,
  });
};

// 获取短信配置信息
export const getSmsConfigLogDetail = (params?) => {
  return http({
    url: '/member-coupon-sms-config/detail',
    params,
  });
};

// 发送短信配置申请
export const getSmsConfigApply = (data) => {
  return http({
    method: 'POST',
    url: '/member-coupon-sms-config/apply',
    data,
  });
};

// 赠券短信模版查询
export const getSmsTemplate = (data) => {
  return http({
    method: 'POST',
    url: '/give/coupon/message/detail',
    data,
  });
};
